import PermissionApi from "../../api/permission-api";
import { cloneDeep } from 'lodash';
import permissionApi from "../../api/permission-api";

export default {
  namespaced: true,
  state: () => ({
    userPermissions: [],
    permissions: [],
    accessibleUrls: [],
    userAccesibleActionIds: [],
    userActions: [],
    userPermissionObjects: [], // collection of all permissions for easy search
    userPermissionGroupObjects: [], // collection of all permissions for easy search
    breadcrumbItems: []
  }),
  getters: {
    checkUserAction: function (state) {
      return (actionId) => {
        const action = state.userActions.find(ua => ua.id == actionId);
        return action;
      };
    },
    canUserAccessUrl: function (state) {
      return (url) => {
        // console.log(url, 'canUserAccessUrl');
        const exists = state.accessibleUrls.find(_url => {
          return _url && _url.toLowerCase() == url.toLowerCase();
        }) != undefined;

        return exists;
      };
    },
    userHasActionPermission: function (state) {
      return (id) => {
        return state.userAccesibleActionIds.find(_id => _id == id) != undefined;
      };
    },
    checkUserHasActionPermission: function (state) {
      return (id) => {

        let isHave = false;
        let userPermissions = state.userPermissions;

        userPermissions.forEach(ups => {
          ups.permissions.forEach(upg => {
            upg.permissionActions.forEach(upac => {
              if (upac.id === id) {
                isHave = true;
                return;
              }
            })
          })
        });

        return isHave;
      };
    },
    userNavs: function (state) {

      let ups = cloneDeep(state.permissions);

      ups = ups.map(up => {
        const idx = state.userPermissions.findIndex(_up => _up.id == up.id);
        if (idx > -1) {
          up.isReadOnly = state.userPermissions.find(_up => _up.id == up.id).isReadOnly;
        }

        up.disabled = idx == -1 ? true : false;
        return up;
      }).sort((up1, up2) => {
        if (up1.orderNumber < up2.orderNumber) return -1;
        if (up1.orderNumber > up2.orderNumber) return 1;
        return 0;
      });

      ups.map(up => {
        up.permissions = up.permissions
          .map(p => {
            const idx = state.userPermissions.findIndex(_up => {
              const _idx = _up.permissions.findIndex(_p => _p.id == p.id);
              return _idx != -1;
            });


            p.disabled = idx == -1 ? true : false;

            return p;
          })
          .sort((p1, p2) => {
            if (p1.orderNumber < p2.orderNumber) return -1;
            if (p1.orderNumber > p2.orderNumber) return 1;
            return 0;
          });

        up.subPermissionGroups = up.subPermissionGroups.map(spg => {
          const idx = state.userPermissions.findIndex(_up => {
            const _idx = _up.subPermissionGroups.findIndex(_spg => _spg.id == spg.id);
            return _idx != -1;
          });

          spg.disabled = idx == -1 ? true : false;

          spg.permissions = spg.permissions
            .map(p => {
              const idx = state.userPermissions.findIndex(_up => {
                const _idx = _up.subPermissionGroups.findIndex(_spg => {
                  const __idx = _spg.permissions.findIndex(_spgp => _spgp.id == p.id);
                  return __idx != -1;
                });
                return _idx != -1;
              });
              p.disabled = idx == -1 ? true : false;
              return p;
            })
            .sort((p1, p2) => {
              if (p1.orderNumber < p2.orderNumber) return -1;
              if (p1.orderNumber > p2.orderNumber) return 1;
              return 0;
            });
          return spg;
        });

        up.subPermissionGroups = up.subPermissionGroups.sort((spg1, spg2) => {
          if (spg1.orderNumber < spg2.orderNumber) return -1;
          if (spg1.orderNumber > spg2.orderNumber) return 1;
          return 0;
        });

        return up;
      });
      // console.log('here lah');
      // console.log(ups)
      return ups;

    }
  },
  mutations: {
    setUserPermission: function (state, permissions) {
      state.userPermissions = permissions;
    },
    setUserAccesibleActionIds: function (state, ids) {
      state.userAccesibleActionIds = ids;
    },
    setAccesibleUrls: function (state, urls) {
      state.accessibleUrls = urls;
    },
    setPermission: function (state, permissions) {
      state.permissions = permissions;
    },
    setUserAction: function (state, uactions) {
      state.userActions = uactions;
    },
    setUserPermissionGroupObjects: function (state, pgo) {
      state.userPermissionGroupObjects = pgo;
    },
    setUserPermissionObjects: function (state, po) {
      state.userPermissionObjects = po;
    },
    setBreadcrumbItems: function (state, items) {
      state.breadcrumbItems = items;
    }
  },
  actions: {
    setUpBreadcrumbs: function ({ state, commit }, { url, params }) {

      let bcItems = [];

      const urlAsAction = state.userActions
        .find(ua => ua.url && ua.url.toLowerCase() == url.toLowerCase());

      const urlAsPermission = state.userPermissionObjects
        .find(ua => ua.url && ua.url.toLowerCase() == url.toLowerCase());

      if (urlAsAction && !urlAsPermission) {

        //console.log('url came from action');

        bcItems.push({
          name: urlAsAction.name,
          url: null
        });

        const ap = state.userPermissionObjects.find(upo => upo.id == urlAsAction.permissionId);

        if (ap) {
          bcItems.push({
            name: ap.name,
            url: ap.url
          });

          const apg = state.userPermissionGroupObjects.find(pgo => {
            return pgo.id == ap.permissionGroupId;
          });

          if (apg) {
            bcItems.push({
              name: apg.name,
              url: apg.url
            });

            if (apg.parentPermissionGroupId) {
              const papg = state.userPermissionGroupObjects.find(pgo => {
                return pgo.id == apg.parentPermissionGroupId;
              });

              if (papg) {
                bcItems.push({
                  name: papg.name,
                  url: papg.url
                });
              }
            }
          }
        }
      } else {
        if (urlAsPermission) {

          //console.log('url came from permission');

          bcItems.push({
            name: urlAsPermission.name,
            url: null
          });

          const apg = state.userPermissionGroupObjects.find(pgo => {
            return pgo.id == urlAsPermission.permissionGroupId;
          });

          //console.log(apg, urlAsPermission);

          if (apg) {
            bcItems.push({
              name: apg.name,
              url: apg.url
            });

            if (apg.parentPermissionGroupId) {
              const papg = state.userPermissionGroupObjects.find(pgo => {
                return pgo.id == apg.parentPermissionGroupId;
              });

              if (papg) {
                bcItems.push({
                  name: papg.name,
                  url: papg.url
                });
              }
            }
          }
        } else {
          const urlAsPermissionGroup = state.userPermissionGroupObjects
            .find(ua => ua.url && ua.url.toLowerCase() == url.toLowerCase());

          if (urlAsPermissionGroup) {

            // console.log('url came from permission group');

            bcItems.push({
              name: urlAsPermissionGroup.name,
              url: urlAsPermissionGroup.url
            });

            if (urlAsPermissionGroup.parentPermissionGroupId) {
              const papg = state.userPermissionGroupObjects.find(pgo => {
                return pgo.id == urlAsPermissionGroup.parentPermissionGroupId;
              });

              if (papg) {
                bcItems.push({
                  name: papg.name,
                  url: papg.url
                });
              }
            }
          }
        }
      }

      bcItems.forEach((bc) => {
        if (bc.url)
          if (bc.url.search(":BookingId") !== -1) {
            bc.url = bc.url.replace(":BookingId", params.BookingId);
          }
      })


      if (bcItems.length !== 0 && bcItems !== null) {
        document.title = `${bcItems[0].name} - PMS`;
      }

      commit('setBreadcrumbItems', bcItems);
    },
    getUserPermissions: function ({ rootGetters,dispatch, state, commit }) {

      return new Promise((resolve, reject) => {
        const user = rootGetters.GetCurrentUserFn();

        if (!user) {
          resolve();
          return;
        }

        const activeLocation = rootGetters.GetActiveLocation;

        if (!activeLocation) {
          resolve();
          return;
        }



        if (state.permissions === null || state.permissions.length === 0) {
          permissionApi.GetPermissions().then((gpres) => {
            const gpresData = gpres.data;

            if (!gpresData.success) {
              throw gpresData.message;
            }

            commit('setPermission', gpresData.data);

            if (state.userPermissions === null || state.userPermissions.length === 0) {
              PermissionApi.GetUserPermissions(user.userId, activeLocation.companyId, activeLocation.pvid).then(res => {
                const resData = res.data;

                if (!resData.success) {
                  throw resData.message;
                }

                const ups = resData.data;
                commit('setUserPermission', ups);

                dispatch('processUserPermission', ups);

                resolve();
              }).catch(error => {
                // console.log(error);
                reject(error);
              });
            } else {
              dispatch('processUserPermission', state.userPermissions);
              resolve();
            }


          }).catch(error => {
            // console.log(error);
            reject(error);
          });
        } else {
          dispatch('processUserPermission', state.userPermissions);
          resolve();
        }


      });
    },
    processUserPermission: function ({ state, commit }, ups) {
      let actionIds = [];
      let urls = [];
      let actions = [];
      let permissions = [];
      let permissionGroups = [];

      ups.forEach(upg => {
        urls.push(upg.url);
        permissionGroups.push(upg);
        upg.permissions.forEach(p => {
          urls.push(p.url);
          permissions.push(p);
          p.permissionActions.forEach(pa => {
            urls.push(pa.url);
            actionIds.push(pa.id);
            actions.push(pa);
          });
        });

        upg.subPermissionGroups.forEach(supg => {
          urls.push(supg.url);
          permissionGroups.push(supg);
          supg.permissions.forEach(p => {
            urls.push(p.url);
            permissions.push(p);
            p.permissionActions.forEach(pa => {
              urls.push(pa.url);
              actionIds.push(pa.id);
              actions.push(pa);
            });
          });
        });
      });

      commit('setUserAccesibleActionIds', actionIds);
      commit('setAccesibleUrls', urls);
      commit('setUserAction', actions);
      commit('setUserPermissionObjects', permissions);
      commit('setUserPermissionGroupObjects', permissionGroups);
    },
    clearClearPermissions: function ({ state, commit }) {
      state.userPermissions = [];
      state.permissions = [];
      state.accessibleUrls = [];
      state.userAccesibleActionIds = [];
      state.userActions = [];
      state.userPermissionObjects = []; // collection of all permissions for easy search
      state.userPermissionGroupObjects = []; // collection of all permissions for easy search
      //state.breadcrumbItems = [];
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/permission.js